export default __webpack_public_path__ + "images/uc-gold-logo.png";